import React, { useMemo } from 'react';
import CandleChart from '../chart/CandleChart';
import { Overlay } from '../chart/types';
import { generateCandles } from '../lib/mockData';
import { ema } from '../indicators/ema';

// Charts workspace. Renders CCFOS's OWN canvas chart (no third-party charting
// library) with mock OHLC data and two EMA overlays from the indicator engine.
// Swap generateCandles() for a live websocket feed once the backend exists.
const ChartsPage: React.FC = () => {
  const candles = useMemo(() => generateCandles(320), []);
  const overlays: Overlay[] = useMemo(
    () => [
      { label: 'EMA 12', color: '#38bdf8', values: ema(candles, 12) },
      { label: 'EMA 26', color: '#f0abfc', values: ema(candles, 26) },
    ],
    [candles]
  );

  return (
    <>
      <section className="page-head">
        <h1>Charts</h1>
        <p className="page-sub">
          A live demo of the CCFOS chart engine — our own renderer, with EMA overlays.
        </p>
      </section>

      <div className="chart-wrap">
        <CandleChart candles={candles} overlays={overlays} height={480} />
      </div>
      <p className="chart-hint">
        🖱️ <strong>Drag</strong> to pan · <strong>Scroll</strong> to zoom · hover for the crosshair &amp; OHLC readout.
        Data shown is randomly generated sample data for demonstration.
      </p>

      <div className="stub-panel" style={{ marginTop: '1.25rem' }}>
        <p>
          This chart is drawn on an HTML canvas by CCFOS's own code — candles, axes,
          pan/zoom, crosshair, and indicator overlays, with no external charting
          library or branding. Ported indicators plug in as overlays via the same
          <code> Candle[] → number[] </code> shape as the EMA above. Everything here
          is an <strong>educational illustration only</strong>.
        </p>
      </div>
    </>
  );
};

export default ChartsPage;
